"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableDrawer.default;
  }
});

var _SwipeableDrawer = _interopRequireDefault(require("./SwipeableDrawer"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/SwipeableDrawer/index.js
// module id = 788
// module chunks = 0